import { motion } from "framer-motion";
import Image from "next/image";
import { useTranslation } from "next-i18next";

const CompanyTeam = () => {
  const { t } = useTranslation('about');

  return (
    <motion.section
      className="py-20 md:py-24"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, margin: "-50px" }}
    >
      <div className="container mx-auto px-6">
        <motion.div
          className="text-center mb-16 md:mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-8">
            {t('team.title')}
          </h2>
          <p className="text-xl md:text-2xl text-secondary-foreground max-w-4xl mx-auto leading-relaxed">
            {t('team.subtitle')}
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto">
          <motion.div
            className="bg-container-background border border-border rounded-3xl overflow-hidden light_effect_card relative group"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            {/* Team Photo */}
            <div className="w-full">
              <Image
                src="/images/team/team.png"
                alt="DeepNeuronic Team"
                width={1200}
                height={800}
                className="w-full h-auto object-cover"
                priority
              />
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default CompanyTeam;
